var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedResize(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74.402,
    height: 71.351,
    viewBox: "0 0 74.402 71.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.036,
    y1: 0.618,
    x2: 0.406,
    y2: 0.447,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ff8066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8066"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.615,
    y1: -0.238,
    x2: 0.263,
    y2: 1.643,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-124.444 -224.063)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 70.995,
    height: 70.995,
    rx: 10,
    transform: "translate(127.851 224.418)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 70.995,
    height: 70.995,
    rx: 12,
    transform: "translate(124.444 224.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M43.646,3.913A1.94,1.94,0,0,0,41.68,2H33.9a1.907,1.907,0,0,0-1.39,3.265l2.27,2.208L25.989,16.02a.938.938,0,0,0,0,1.353l1.854,1.8a1,1,0,0,0,1.39,0l8.786-8.547,2.27,2.208a1.974,1.974,0,0,0,3.357-1.353ZM21.354,20.529l-8.787,8.547L10.3,26.868a1.974,1.974,0,0,0-3.357,1.353v7.572a1.94,1.94,0,0,0,1.966,1.913h7.784a1.907,1.907,0,0,0,1.39-3.265l-2.27-2.208L24.6,23.685a.938.938,0,0,0,0-1.353l-1.854-1.8A1,1,0,0,0,21.354,20.529Z",
    transform: "translate(134.503 240.063)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedResize);
export default __webpack_public_path__ + "static/media/red_resize.48734fbf41a74a416d5cf7fbbe3c5ccb.svg";
export { ForwardRef as ReactComponent };